<div class="matrix_layoutMain container"  v-bind:class="getClassNameContainer">
    <div class="row">
        <div class="col-md-6 flex" >           
            <appQuantitySelectionContainer></appQuantitySelectionContainer> 
            <appCostCenter></appCostCenter>
            <appPersonalizationButton></appPersonalizationButton>
            <appAddToCartButton style="display: none"></appAddToCartButton>               
        </div>
    </div>    
</div>